export const embedMetadataToElement = (metadataInfo, metadataClass) => {
  let metadataInfoString = "";
  let keyClass = "";
  let valueClass = "";
  if(metadataInfo){
    let metadataElement = document.getElementById(metadataClass);
    if(metadataElement){
      for( let prop in metadataInfo){
        keyClass = prop.replace(/\s+/g, '-').toLowerCase();
        valueClass = metadataInfo[prop].replace(/\s+/g, '-').toLowerCase();
        metadataInfoString += `<li class="metadata-li"><div class="metadata-key ${keyClass}">${prop}</div> <div class="metadata-value ${valueClass}">${metadataInfo[prop]}</div></li>`
      }
      metadataElement.innerHTML = `<ul class="metadata-ul">${metadataInfoString}</ul>`
    }
  }
}

